import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export default function organizationsReducer(
  state = initialState.organizations,
  action,
) {
  switch (action.type) {
    case actionTypes.USER_ORGANIZATIONS_GET_SUCCESS: {
      return action.data ? [...action.data] : [];
    }
    default: {
      return state;
    }
  }
}
